/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Context_MissingInputs */



/**
* | output |
* | --- |
* | "Not reported by the server. Enter the model's context window (at least 128,000 tokens)." |
*
* @param {Private_Models_Context_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_context_missing = /** @type {((inputs?: Private_Models_Context_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Context_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vom Server nicht gemeldet. Tragen Sie das Kontextfenster des Modells ein (mindestens 128.000 Tokens).")
	return /** @type {LocalizedString} */ ("Not reported by the server. Enter the model's context window (at least 128,000 tokens).")
});